module.exports = __webpack_public_path__ + "img/symbol_7.1a00fe9f.png";